import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Routes as GlobalRoutes } from "../../constants/RouteConstants";

/** Marks the orders list page so order-only UI overrides can target modals in the portal. */
export function MyOrdersPageBodyClass() {
  const { pathname } = useLocation();

  useEffect(() => {
    const orderPath = GlobalRoutes.Order?.replace(/\/$/, "") || "/order";
    const onOrdersList = pathname === orderPath || pathname === `${orderPath}/`;
    document.body.classList.toggle("page-my-orders", onOrdersList);
    return () => {
      document.body.classList.remove("page-my-orders");
    };
  }, [pathname]);

  return null;
}
